import React from 'react'
import { Flex } from 'rebass/styled-components'
import styled from 'styled-components'

const Loading = () => (
    <StyledLoading viewBox="0 0 50 50">
        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="2" />
    </StyledLoading>
)

const StyledLoading = styled.svg`
    animation: dash 1s linear infinite;
    margin: 40px;
    width: 50px;
    height: 50px;

    & .path {
        stroke: ${({ theme }) => theme.colors.primary};
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }
    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }
`

const FullLoading = () => (
    <Flex
        css={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 9,
            background: 'rgba(0,0,0,0.3)',
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        <Loading />
    </Flex>
)

export default FullLoading
